import EventCity from "../../eventCities/types/EventCity";
import City from "../../cities/types/City";
import Department from "../types/Department";
import Event from "../../events/types/Event";
import useEventCityGet from "../../eventCities/hooks/useEventCityGet";
import useEventGet from "../../events/hooks/useEventGet";
import useCityGet from "../../cities/hooks/useCityGet";
import useDepartmentGet from "./useDepartmentGet";



interface UseTransferRequestDataOutput {
    eventCity?: EventCity;
    event?: Event;
    city?: City;
    department?: Department;
    isLoading: boolean;
    isEventCityLoading: boolean;
    isEventLoading: boolean;
    isCityLoading: boolean;
    isDepartmentLoading: boolean;
}

export default function useTransferRequestData(
    eventCityId: string | undefined,
    departmentId: string | undefined
): UseTransferRequestDataOutput {
    // Get EventCity by ID
    const eventCityQuery = useEventCityGet(eventCityId || "");
    const {data: eventCity, isLoading: isEventCityLoading} = eventCityQuery;

    // Get Event from eventCity
    const eventQuery = useEventGet(eventCity?.event ?? 0, { execute: !!eventCity?.event });
    const {data: event, isLoading: isEventLoading} = eventQuery;

    // Get City data
    const cityInfoQuery = useCityGet(eventCity?.city ?? 'cities/0', {execute: !!eventCity?.city});
    const {data: city, isLoading: isCityLoading} = cityInfoQuery;

    // Get department data based on ID
    const departmentQuery = useDepartmentGet(departmentId || "");
    const {data: departmentData, isLoading: isDepartmentLoading} = departmentQuery;
    const department = departmentData as Department | undefined;

    // Combine loading states
    const isLoading = isEventCityLoading || isEventLoading || isDepartmentLoading || isCityLoading;

    return {
        eventCity,
        event,
        city,
        department,
        isLoading,
        isEventCityLoading,
        isEventLoading,
        isCityLoading,
        isDepartmentLoading,
    };
}

